export default __webpack_public_path__ + "static/wrench_w.0b63dc200544dd7b737fc9f87df2352c.png";